// extracted by mini-css-extract-plugin
module.exports = {"icon":"legislation_parts-module__icon--13sth"};